import Store from 'repatch';

import State from '../core/State';
import { clearSnackbar, setSnackbar } from '../thunk/snackbar';

export type NotifyOptions = {
  messageValues?: Record<string, any> | null;
  action?: string | null;
  actionValues?: Record<string, any> | null;
  isRaw?: boolean;
  onClickAction?: (() => void) | null;
  isAutoHide?: boolean;
};

class MessageDispatcher {
  private readonly store: Store<State>;

  constructor({ store }: { store: Store<State> }) {
    this.store = store;
  }

  public notifyUnimportant = (
    message: string,
    {
      messageValues = null,
      action = null,
      actionValues = null,
      isRaw = false,
      onClickAction = null,
      isAutoHide = true,
    }: NotifyOptions = {},
  ) => {
    this.store.dispatch(
      setSnackbar({
        message,
        messageValues: messageValues,
        action: action,
        actionValues: actionValues,
        isRaw,
        onClickAction,
        isAutoHide,
      }),
    );
  };

  public clearUnimportant = () => {
    this.store.dispatch(clearSnackbar());
  };
}

export default MessageDispatcher;
